import * as React from 'react'
import { useLocation } from 'react-router-dom'

import { Container, ContainerBody } from 'uiComponents/settingsContainer'
import SettingsSectionTabs from './sectionTabs'
import { SETTINGS_TABLE_HEADER_SLOT_ID } from './tableHeaderSlot'
import { ContractEditWarning } from './contract/contractEditWarning'

interface AccountSettingsProps {
    children?: React.ReactNode
}

const AccountSettingsPageContainer: React.FC<AccountSettingsProps> = ({ children }) => {
    const location = useLocation()

    return (
        <div style={{ position: 'relative' }} id="account-settings">
            <SettingsSectionTabs />
            <ContractEditWarning />
            <div className="settings-table-header" id={SETTINGS_TABLE_HEADER_SLOT_ID} />
            <Container>
                <ContainerBody noPadding={location.pathname.includes('reporting_categories')}>{children}</ContainerBody>
            </Container>
        </div>
    )
}

export default AccountSettingsPageContainer
